import { api } from "./dataService";

export const fetchClaimForm = async (claim_form_id) => {
  return (await api.get(`data/claim-forms/${claim_form_id}`)).data;
};

export const updateClaimForm = async (claim_form_id, payload) => {
  return (await api.patch(`data/claim-forms/${claim_form_id}`, payload)).data;
};

export const fetchClaimFormDefinitions = async (claim_form_id) => {
  return (await api.get(`data/claim-forms/${claim_form_id}/definitions`)).data;
};

export const createClaimFormDefinition = async (claim_form_id, payload) => {
  return (await api.post(`data/claim-forms/${claim_form_id}/definitions`, payload)).data;
};

export const downloadClaimFormDefinitionDocx = async (claim_form_id, definition_id, filename) => {
  const response = await api.get(
    `data/claim-forms/${claim_form_id}/definitions/${definition_id}/download`,
    { responseType: "blob" }
  );

  const blob = new Blob([response.data]);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename || "vorlage.docx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

export const attachSparte = async (claim_form_id, sparte_id, coverage_type) => {
  return (
    await api.post(`data/claim-forms/${claim_form_id}/sparten`, {
      sparte_id,
      ...(coverage_type ? { coverage_type } : {}),
    })
  ).data;
};

export const updateSparte = async (claim_form_id, sparte_id, changes) => {
  return (await api.patch(`data/claim-forms/${claim_form_id}/sparten/${sparte_id}`, changes)).data;
};

export const updateSparten = async (claim_form_id, sparte_ids, changes) => {
  return (
    await api.patch(`data/claim-forms/${claim_form_id}/sparten`, {
      sparte_ids,
      ...changes,
    })
  ).data;
};

export const fetchClaimCauses = async () => {
  return (await api.get("data/schaden_ursachen_select")).data;
};

export const fetchClaimCauseArten = async () => {
  return (await api.get("data/schaden-arten-select")).data;
};

export const detachSparte = async (claim_form_id, sparte_id) => {
  await api.delete(`data/claim-forms/${claim_form_id}/sparten/${sparte_id}`);
};

export const fetchUnassignedSparten = async (searchword = "") => {
  return (
    await api.get("data/sparten", {
      params: {
        filter: {
          has_claim_form: "0",
          ...(searchword ? { _searchword: searchword } : {}),
        },
      },
    })
  ).data;
};
